import React, {CSSProperties} from 'react';

/**
 * {@docCategory VerticalSpacer}
 */
export interface VerticalSpacerProps {
   /**
    * The size of the spacer.
    *
    * @defaultvalue medium
    */
   size?: 'small' | 'medium' | 'large';

   /**
    * Sets a className on the component.
    */
   className?: string;

   /**
    * Sets styles on the component.
    */
   style?: CSSProperties;
}

export const VerticalSpacer = (props: VerticalSpacerProps) => {
   const size = props.size || 'medium';

   return (
      <div className={`uf-spacer-vertical-${size} ${props.className || ''}`} style={props.style}/>
   );
};
